import React, {useState} from 'react';

import {EventTriggerAttachmentView} from 'src/modules/event/event-trigger-attachment/event-trigger-attachment.view';
import {getEventById} from 'src/openapi/apis/EventControllerApi';
import {addAttachmentToEvent} from 'src/openapi/apis/TriggerAttachmentControllerApi';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    eventDetailInfo: EventDetailInfo,
};

const ERROR_AUTO_HIDE_TIMEOUT = 10000;
const SUCCESS_AUTO_HIDE_TIMEOUT = 2000;
const ERROR_MESSAGE = 'Failed to upload attachment. Check whether there is an open change request.';

export const EventTriggerAttachmentController = ({eventDetailInfo}: Props) => {
    const {onCreateNote} = usePushNotification();
    const dispatch = useAppDispatch();
    const [isUploading, setIsUploading] = useState<boolean>(false);

    const onUploadFiles = async (acceptedFiles: File[]) => {
        if (acceptedFiles.length === 0 || isUploading) {
            return;
        }

        const file = acceptedFiles[0];

        setIsUploading(true);

        const response =
            await dispatch(addAttachmentToEvent({eventId: eventDetailInfo.id, file}));

        setIsUploading(false);

        if (response.payload.success) {
            await dispatch(getEventById({id: eventDetailInfo.id}));
            await onCreateNote({
                id: 'uploadTriggerAttachmentSuccess',
                status: Status.SUCCESS,
                message: 'Uploaded',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: SUCCESS_AUTO_HIDE_TIMEOUT,
            });
        }

        if (response.payload.error) {
            await onCreateNote({
                id: 'uploadTriggerAttachmentFailure',
                status: Status.ERROR,
                message: ERROR_MESSAGE,
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
            });
        }
    };

    return (
        <EventTriggerAttachmentView
            eventDetailInfo={eventDetailInfo}
            triggerAttachments={eventDetailInfo.triggerAttachments}
            isUploading={isUploading}
            onUploadFiles={onUploadFiles}
        />
    );
};
